const NON_EMOJI_REGEX = /\w|\d/

export const isInvalidIcon = (emoji: string): false | string => {
  if (!emoji || NON_EMOJI_REGEX.test(emoji)) {
    return 'Please only enter an Emoji.'
  }

  return false
}
